// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3pols","colCheckbox":"styles_colCheckbox__1HRNa"};